export const iconColor = "#636291";
export const primaryColor = "#b5c0e8";
export const buttonStyle = {boxShadow: "5px 5px 0px #c26255 !important", fontWeight: 600};